import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface MessageDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
  dismissButtonText?: string;
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
}

const MessageDialog: React.FC<MessageDialogProps> = ({
  open,
  title,
  message,
  onClose,
  dismissButtonText,
  secondaryButtonText,
  onSecondaryButtonClick
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontSize: "16px" }}>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        {secondaryButtonText && onSecondaryButtonClick && (
          <Button onClick={onSecondaryButtonClick} color="secondary">
            {secondaryButtonText}
          </Button>
        )}
        <Button onClick={onClose} color="primary">
          {dismissButtonText ??
            t("ROOSTER.PUBLIC-APP.DISMISS", {
              defaultValue: "Dismiss"
            })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;
